'use client';
import { toast } from '@/components/ui/use-toast';
import Image from 'next/image';
import Link from 'next/link';

const ServiceCard = ({
    logo,
    title,
    href,
}: {
    logo: string;
    title: string;
    href: string;
}) => {
    return (
        <Link
            onClick={(event) => {
                if (title === 'چکاپ سلامت جسم') {
                    event.preventDefault();
                    toast({
                        title: 'در دست توسعه است...',
                        variant: 'success',
                    });
                }
            }}
            href={title === 'چکاپ سلامت جسم' ? '' : href}
            className="text-center"
        >
            <div
                id="home_service_item"
                className="rounded-full mx-auto transition-shadow hover:shadow-[0px_2px_14px_0px_#00000040] hover:border-2 hover:border-white smp:!size-[85px] size-[75px] lg:!size-[110px] flex items-center justify-center p-1 bg-white shadow-md"
            >
                <Image
                    src={logo}
                    className="lg:!w-[75px] lg:!h-[65px] sm:!w-[60px] sm:!h-[55px] w-[50px] h-[45px]"
                    width={1000}
                    height={1000}
                    alt={`${title}-درمان شیرین`}
                />
            </div>
            <p className="text-sm font-semibold pt-2">{title}</p>
        </Link>
    );
};

export default ServiceCard;
